import styled from 'styled-components';

export default styled.li`
    font-size: ${({theme}) => theme.fontSize.s};
`;
